import React from 'react';
import OwlCarousel from 'react-owl-carousel';

const Clients = props => (
  <div style={{ backgroundColor: '#ddd' }}>
    <div className="padding-top-large" />
    <div className="clients-slider-1x">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="clients-logo-slider">
              <OwlCarousel className="owl-carousel clients-slider" items={5} dots={false} loop autoplay margin={0}>
                {props.clients.map(client => (
                  <div className="item" key={client.logo}>
                    <a href={client.link}>
                      <img src={client.logo} alt={client.name} className="" target="_blank" />
                    </a>
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="padding-top-large" />
  </div>
);

export default Clients;



// WEBPACK FOOTER //
// ./src/components/Clients.js